import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Stack,
  Box,
  SvgIcon,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as DistanceCalculation } from "../../../assets/images/distance-calculate-formula.svg";
import { ReactComponent as hintBlub } from "../../../assets/images/hintBlub.svg";

import "./Mission3HintPopUp.scss";

const Mission3HintPopUp = ({ open, onClose, level = "intermediate" }) => {
  // Check if hints is an object with text and image properties
  // This handles both the new format (object with text/image) and old format (array of strings)

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: "m3-hint-popup" }}
      disableEnforceFocus
      slotProps={{
        backdrop: {
          className: "custom-backdrop",
        },
      }}
      maxWidth="950px"
    >
      <Box>
        <DialogActions className="hint-actions">
          <IconButton className="close-button" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogActions>

        <DialogContent dividers className="hint-content-popup">
          <SvgIcon component={hintBlub} className="hint-icon" inheritViewBox />
          <p className="title"> Hints</p>

          <Stack display={"flex"} direction={"row"} useFlexGap gap={2}>
            <Stack width={"50%"}>
              <p>
                You can calculate the bearing of the drone between 2 points
                using the following format:
              </p>
              <SvgIcon
                component={DistanceCalculation}
                alt="distance-cal-calculation-formula"
                className="hint-diagram"
                inheritViewBox
                // style={{ maxWidth: "80%", borderRadius: "4px" }}
              />
            </Stack>
            <Divider
              orientation="vertical"
              className="hint-divider"
              sx={{
                borderColor: "var(--popup-border)",
                height: "200px",
                borderWidth: "1px",
              }}
            />
            <Stack width={"50%"}>
              <h4>Calculating Waypoints</h4>
              <p>
                Traveling <span className="d">d</span> metres from{" "}
                <span className="exp">(x₁,y₁) </span>on a heading of{" "}
                <span className="d">h</span> degrees to{" "}
                <span className="exp">(x₂,y₂)</span>
              </p>
              <pre className="formula">x₂ = x₁ + (d sin h)</pre>
              <pre className="formula">y₂ = y₁ + (d cos h)</pre>
            </Stack>
          </Stack>
          {level.toLocaleLowerCase() !== "intermediate" && (
            <>
              <Divider
                orientation="vertical"
                className="hint-divider"
                sx={{
                  borderColor: "var(--popup-border)",
                  // height: "200px",
                  borderWidth: "1px",
                }}
              />

              <ul className="m3-advanced-hint">
                <li className="text">
                  In this mission, a heading of 0° points East (to the right on
                  the map).
                </li>
                <li className="text">
                  Angles increase counter-clockwise (90° = North, 180° = West,
                  270° = South).
                </li>
                <li className="text">
                  If you prefer compass bearings (0° = North, clockwise),
                  convert using: bearing = (90 − h + 360) % 360.
                </li>
              </ul>
            </>
          )}
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default Mission3HintPopUp;
